import {schoolSearchActionTypes as types} from '../constants';
import initialState from './initialState';

function schoolSearchStatus(state = initialState, action) {
  switch (action.type) {
    case types.INITIALIZE_USER_SCHOOL_UPDATE_REQUEST:
      return {...state, isError: false, isLoading: true, isSuccess: false};
    case types.SCHOOLS_LOAD_REQUEST:
      return {...state, isError: false, isLoading: true, isSuccess: false, items: []};
    case types.SCHOOLS_LOAD_SUCCESS:
      return {...state, isError: false, isLoading: false, isSuccess: true, items: action.payload.data};
    case types.SCHOOLS_LOAD_FAILURE:
      return {...state, isError: true, isLoading: false, error: action.error};
    case types.SCHOOL_SEARCH_LOAD_SUCCESS:
      return {...state, isError: false, isLoading: false, isSuccess: true};
    case types.SCHOOL_SEARCH_LOAD_FAILURE:
      return {...state, isError: true, isLoading: false, isSuccess: false};
    default:
      return state;
  }
}

export default schoolSearchStatus;
